import { useMemo } from 'react'

import { createIsSpeakingObserver } from '@livekit/components-core'
import type { Participant } from 'livekit-client'

import { useEnsureParticipant } from '@/src/context'

import { useObservableState } from '@/src/hooks/internal'

/**
 * The `useIsSpeaking` hook returns a `boolean` that indicates if the participant is speaking or not.
 * @example
 * ```tsx
 * const isSpeaking = useIsSpeaking(participant);
 * ```
 * @public
 */
export function useIsSpeaking(participant?: Participant) {
  const p = useEnsureParticipant(participant)
  const observable = useMemo(() => createIsSpeakingObserver(p), [p])
  const isSpeaking = useObservableState(observable, p.isSpeaking)

  return isSpeaking
}
